define('editor/edit/map/controls/drawing-tools',['durandal/app', 'plugins/http', 'jquery', 'knockout', 'knockout-mapping', '../../layers/edit/markerStyleTracker', 'leaflet-draw'], function (app, http, $, ko, komapping, markerStyleTracker) {
  var control = function (options) {
    var self = this;

    self.editorMapId = options.editorMapId;
    self.defaultMarkerIcon = '/content/icons/default/Markers/capitalcity_02.svg';
    self.map = options.mapControl;
    self.featureGroup = L.featureGroup().addTo(self.map);
    self.layerLeafletIdDictionary = [];
    self.editingLayerId = null; // layer currently under edit (to enable things like dragging etc..)

    self.addToMap = function (allowEdit) {
      if (allowEdit) {
        var drawingOptions = {
          draw: {
            polygon: {
              shapeOptions: {
                color: '#FE2712'
              }
            },
            polyline: {
              shapeOptions: {
                color: '#FE2712'
              }
            },
            rectangle: {
              shapeOptions: {
                color: '#FE2712'
              }
            },
            circle: {
              shapeOptions: {
                color: '#FE2712'
              }
            }
          },
          edit: {
            edit: false, // remove button from toolbar
            remove: false, // remove button from toolbar
            featureGroup: self.featureGroup // store layers for editing
          }
        };

        self.drawControl = new L.Control.Draw(drawingOptions)
            .addTo(self.map);
      }

      self.registerEventHandlers();
    };

    self.registerEventHandlers = function () {
      app.on('layers:newData', self.refreshShapes);
      app.on('layer:new', self.renderNewShape);

      app.on('layer:editing', self.enableShapeEdit);
      app.on('layers:updated', self.onLayersUpdated);
      app.on('layer:saved', self.lockLayerAfterEdit);
      app.on('layers:deleted', self.deleteShapes);
      app.on('layer:visibility', self.onToggleLayerVisibility);

      app.on('layer:item-selected', self.selectItem);
      app.on('layer:item-deselected', self.deselectItem);

      self.map.on('draw:created', self.onShapeDrawn);
      self.map.on('draw:drawstart', self.onDrawStart);
    };

    self.selectItem = function (layerId) {
      $('.item-id-' + layerId).attr('class', function(index, classNames) {
        return classNames + ' selected-item';
      });
    };

    self.deselectItem = function (layerId) {
      $('.item-id-' + layerId).attr('class', function (index, classNames) {
        return classNames.replace(/selected-item/g, '').trim();
      });
    };

    self.refreshShapes = function (layers) {
      var layersLen = layers().length;

      self.clearShapes();

      var groupIds = ko.utils.arrayMap(layers(), function (layer) {
        return layer.groupId();
      });
      var uniqueGroupIds = ko.utils.arrayGetDistinctValues(groupIds);
      for (var j = 0; j < uniqueGroupIds.length; j++) {
        var markers = ko.utils.arrayFilter(layers(), function (layer) {
          return layer.groupId() === uniqueGroupIds[j] && layer.type() === 'Marker';
        });
        for (var k = 0; k < markers.length; k++) {
          if (markers[k].state().isAutoNumber && markers[k].state().isAutoNumber()) {
            var number = k > 8 ? k + 1 : '0' + (k + 1);
            var numberedIcon = markers[k].state().selectedicon().replace(/\d\d.svg/g, number + '.svg');
            markers[k].state().selectedicon(numberedIcon);
          }
        }
      }

      for (var i = 0; i < layersLen; i++) {
        var layer = layers()[i];

        self.renderLayerShape(layer);
      }

      // shape layers come from server in order
      // svg doesn't know about z-index, so must reverse the paths in the DOM
      self.reorderVectorLayers();
    };

    self.onToggleLayerVisibility = function (layer) {
      self.refreshShape(layer);

      if (layer.visible() && self.isVectorLayer(layer)) {
        self.moveEditedVectorLayerTo(layer.order());
      }
    };

    self.renderNewShape = function (layer) {
      self.renderLayerShape(layer);

      if (self.isVectorLayer(layer)) {
        self.moveEditedVectorLayerTo(layer.order());
      }
    };

    self.renderLayerShape = function (layer) {
      switch (layer.type()) {
        case "Rectangle":
        case "Polyline":
        case "Polygon":
        case "GeoJSON":
          self.renderVector(layer);
          break;
        case "Circle":
          self.renderCircle(layer);
          break;
        case "Marker":
          self.renderMarker(layer);
          break;
        default:
          break;
      }
    };

    self.reorderVectorLayers = function () {
      var svgs = $('svg');

      svgs.each(function (index, value) {
        var svg = $(value);
        var paths = $('g', svg);

        svg.append(paths.get().reverse());
      });
    };

    self.onShapeDrawn = function (e) {
      var type = e.layerType,
          layer = e.layer,
          geojson = layer.toGeoJSON();

      geojson.properties = layer.options;

      if (type === "circle") {
        geojson.properties.radius = layer._mRadius;
      }
      if (type === "marker") {
        geojson.html = "New Marker";
        geojson.properties.icon.options.iconSize = [30, 42];
        geojson.properties.icon.options.iconAnchor = [15, 35];
        geojson.properties.cancelToDelete = true;

        if (markerStyleTracker.previousEditStyle) {
            geojson.selectedicon = markerStyleTracker.previousEditStyle.icon;

            geojson.visibilityOptions = {
                iconVisible: markerStyleTracker.previousEditStyle.iconVisible,
                labelVisible: markerStyleTracker.previousEditStyle.labelVisible,
                paddleVisible: markerStyleTracker.previousEditStyle.paddleVisible
            };

            geojson.iconColour = markerStyleTracker.previousEditStyle.iconColour;
            geojson.paddleColour = markerStyleTracker.previousEditStyle.paddleColour;
            geojson.labelTextColor = markerStyleTracker.previousEditStyle.labelTextColor;
            geojson.textShadowColour = markerStyleTracker.previousEditStyle.labelGlowColour;
            
            geojson.textSize = markerStyleTracker.previousEditStyle.labelTextSize;
            geojson.iconSize = markerStyleTracker.previousEditStyle.iconSize;
            geojson.textAlign = markerStyleTracker.previousEditStyle.labelAlignment;
        } else {
            geojson.selectedicon = self.defaultMarkerIcon;

            geojson.visibilityOptions = {
                iconVisible: false,
                labelVisible: true,
                paddleVisible: true
            };

            geojson.iconColour = "#FFFFFF";
            geojson.paddleColour = "#808080";
            geojson.labelTextColor = '#000000';
            geojson.textShadowColour = '#FFFFFF';

            geojson.textSize = 'normal';
            geojson.iconSize = "normal";
            geojson.textAlign = 'below';
        }
      }

      self.createNewLayer(type, geojson);
    };

    self.onDrawStart = function () {
      app.trigger('layers:drawing');
    };

    self.renderVector = function (layer) {
      self.renderShape(layer);
    };

    self.renderMarker = function (layer) {
      var pointToLayer = function (feature, latlng) {
        var iconOptions = {},
            classNames = [
                'marker-icon',
                'marker-icon-' + layer.state().iconSize(),
                'marker-label-' + layer.state().textSize(),
                'marker-label-' + layer.state().textAlign(),
                'item-id-'+ layer.id()
            ],
            labelStyles = [];

        labelStyles.push("color: " + (layer.state().labelTextColor()) + ";");

        if (layer.state().textShadowColour() !== "") {
          var colour = layer.state().textShadowColour(),
              val;

          if (colour.indexOf('#FFF') === 0) {
            val = '0 0 0.3em #FFF, 0 0 0.3em #FFF, 0 0 0.3em #FFF, 0 0 0.3em #FFF, 0 0 0.3em #FFF, 0 0 0.3em #FFF;';
          } else {
            val = '0 0 0.3em ' + colour + ';';
          }

          labelStyles.push("text-shadow: " + val);
        }

        iconOptions.iconSize = layer.state().properties.icon.options.iconSize();
        iconOptions.iconAnchor = layer.state().properties.icon.options.iconAnchor();
        iconOptions.html = '';

        var selectedicon = layer.state().selectedicon();
        var iconColour = layer.state().iconColour();
        var iconSize = layer.state().iconSize();
        var paddleVisible = layer.state().visibilityOptions.paddleVisible();
        var iconVisible = layer.state().visibilityOptions.iconVisible();
        var paddleColour = layer.state().paddleColour();
        var isSvg = selectedicon.endsWith('.svg');
        var svg = '';
        var markerStyle = ';width:43px;margin-left:-10px;margin-top:-3px;';
        var iconStyle = ';width:43px;margin-left:-10px;margin-top:-3px;';

        switch (iconSize) {
            case 'small':
                iconOptions.iconSize = [15, 21];
                markerStyle = ';width:30px;margin-left:-3px;margin-top:10px;';
                iconStyle = paddleVisible ? ';width:15px;margin-top:13px;margin-left:5px;' : markerStyle;
                break;
            case 'large':
                iconOptions.iconSize = [40, 47];
                markerStyle = ';width:56px;margin-left:-16px;margin-top:-15px;';
                iconStyle = paddleVisible ? ';width:31px;margin-top:-10px;margin-left:-3px;' : markerStyle;
                break;
            case 'xlarge':
                iconOptions.iconSize = [50, 60];
                markerStyle = ';width:70px;margin-left:-23px;margin-top:-29px;';
                iconStyle = paddleVisible ? ';width:40px;margin-top:-26px;margin-left:-8px;' : markerStyle;
                break;
            case 'xxlarge':
                iconOptions.iconSize = [60, 75];
                markerStyle = ';width:86px;margin-left:-31px;margin-top:-46px;';
                iconStyle = paddleVisible ? ';width:48px;margin-top:-40px;margin-left:-12px;' : markerStyle;
                break;
            default:
                iconStyle = paddleVisible ? ';width:24px;' : markerStyle;
                break;
        }

        if (paddleVisible) {
            svg += '<svg viewBox="0 0 32 32" style="fill:' + paddleColour + markerStyle + '">';
            svg += '<use xlink:href="/content/img/icons/marker.svg#Layer_1"></use>';
            svg += '</svg>';
        }

        if (iconVisible) {
            svg += '<svg viewBox="0 0 32 32" style="fill:' + iconColour + iconStyle + '">';
            svg += '<use xlink:href="' + selectedicon + '#Layer_1"></use>';
            svg += '</svg>';
        }

        iconOptions.html = !isSvg ? '<img src=\"' + selectedicon + '\" />' : svg;

        var iconLabel = layer.state().html().convertNewLinesToHtml();

        if (layer.state().visibilityOptions.labelVisible()) {
          iconOptions.html += '<span style=\"' + labelStyles.join(' ') + '\">' + iconLabel + '</span>';
        }

        iconOptions.className = classNames.join(' ');

        var enableInteraction = self.editingLayerId === layer.id();
        var customIcon = L.divIcon(iconOptions),
            marker = new L.Marker(latlng, {
              icon: customIcon,
              zIndexOffset: 100 * -layer.order(),
              draggable: enableInteraction,
              clickable: enableInteraction
            });

        marker.on('dragend', function (event) {
          // we dont update the layer state here,
          // instead just raise an event and let the edit panel do it
          var newPos = event.target.getLatLng();
          var id = layer.id();
          app.trigger('marker:moved', { newPos: newPos, id: id });
        });        

        return marker;
      };

      self.renderShape(layer, pointToLayer);
    };

    self.renderCircle = function (layer) {
      var pointToLayer = function (feature, latlng) {
        var state = ko.toJS(layer.state());
        return L.circle(latlng, state.properties.radius, state.properties);
      };

      self.renderShape(layer, pointToLayer);
    };

    self.renderShape = function (layer, pointToLayer) {
        layer.state().properties.className = "item-id-" + layer.id();
      var featureOptions = {
        style: function (feature) {
          return feature.properties;
          },
        onEachFeature: function (feature, geoLayer) {
            geoLayer.on('mouseover', function () {
                app.trigger('layer:item-selected', layer.id());
            });

            geoLayer.on('mouseout',function() {
                app.trigger('layer:item-deselected', layer.id());
            });
        } 
      };

      if (pointToLayer) {
        featureOptions.pointToLayer = pointToLayer;
      }

      try {        
          var state = ko.toJS(layer.state());
          
        // create a geojson class representing our shape
        var geojson = L.geoJson(state, featureOptions);

        if (layer.visible()) {
          geojson.addTo(self.featureGroup);
        }

        // store the leaflet layer against the layer id for easy retrieval
        self.layerLeafletIdDictionary[layer.id()] = geojson._leaflet_id;

        // enable vector editing, if currently editing this shape
        if (self.editingLayerId === layer.id() && self.isVectorLayer(layer)) {
          self.enableVectorEditing(layer);
        }
      } catch (e) {
        // tried to import invalid geojson?
        app.showMessage('Layer data invalid for: "' + layer.name() + '"<br/><br/>"' + e.message + '"', 'Invalid Layer Data');
      }
    };

    self.clearShapes = function () {
      if (self.featureGroup) {
        self.featureGroup.clearLayers();
      }
    };

    self.createNewLayer = function (type, state) {
      var url = "/api/editor/layers/add";
      var data = {
        editorMapId: self.editorMapId,
        type: type,
        state: state
      };

      return http.post(url, data)
          .then(function (response) {
            if (response.success) {
              var layerData = response.data["createdLayer"],
                  layerState = komapping.fromJS(layerData.state),
                  layer = {
                    id: ko.observable(layerData.id),
                    name: ko.observable(layerData.name),
                    groupId: ko.observable(data.groupId),
                    groupName: ko.observable(data.groupName),
                    groupColour: ko.observable(data.groupColour),
                    visible: ko.observable(layerData.visible),
                    type: ko.observable(layerData.type),
                    order: ko.observable(layerData.order),
                    state: ko.observable(layerState),
                    isGroup: ko.observable(false)
                  };

              delete layerState['__ko_mapping__'];

              app.trigger("layer:new", layer);
            } else {
              app.showMessage("Failed to add layer", "Add Layer");
            }
          }).fail(function () {
            app.showMessage("Failed to add layer", "Add Layer");
          });
    };

    self.onLayersUpdated = function (layers) {
      var layersLen = layers.length,
          layer;

      for (var i = 0; i < layersLen; i++) {
        layer = layers[i];

        self.refreshShape(layer);
      }
    };

    self.refreshShape = function (layer) {
      self.deleteShapes([layer]);
      self.renderLayerShape(layer);

      // todo: use layer.refresh() or layer.setStyle()?
    };

    self.deleteShapes = function (layers) {
      var deletedLayersLen = layers.length,
          layerToDelete,
          fGroupLayerId;

      for (var i = 0; i < deletedLayersLen; i++) {
        layerToDelete = layers[i];
        fGroupLayerId = self.layerLeafletIdDictionary[layerToDelete.id()];

        if (fGroupLayerId) {
          self.featureGroup.removeLayer(fGroupLayerId);

          delete self.layerLeafletIdDictionary[layerToDelete.id()];
        }
      }
    };

    self.enableShapeEdit = function (layer) {
      self.editingLayerId = layer.id();
      self.refreshShape(layer);
    };

    self.enableVectorEditing = function (layer) {
      var shape = self.findShapeByLayerId(layer.id());

      shape.editing.enable();

      shape.on('edit', function (e) {
        self.handleVectorLayerShapeEdited(layer, e.target);
      });
    };

    self.handleVectorLayerShapeEdited = function (layer, shape) {
      var geoJson = shape.toGeoJSON(),
          mapped;

      geoJson.properties.radius = shape._mRadius;
      mapped = komapping.fromJS(geoJson);

      delete mapped['__ko_mapping__'];

      layer.state(mapped);
    };

    self.lockLayerAfterEdit = function (layer) {
      self.editingLayerId = null;
      self.refreshShape(layer);

      // the edited shape DOM element has been recreated & appended to list,
      // so move it back to its proper position
      if (self.isVectorLayer(layer)) {
        self.moveEditedVectorLayerTo(layer.order());
      }
    };

    self.moveEditedVectorLayerTo = function (index) {
      var svgs = $('svg');

      svgs.each(function(index, value) {
        var svg = $(value);

        var g = $.makeArray($('g', svg)).reverse();
        var edited = $(g).first();
        var sibling = $(g)[index + 1];

        edited.remove();

        if (!sibling) {
          svg.prepend(edited);
        } else {
          edited.insertAfter(sibling);
        }
      });
    };

    self.findShapeByLayerId = function (layerId) {
      var leafletId = self.layerLeafletIdDictionary[layerId];
      var layerLayers = self.featureGroup._layers[leafletId]._layers;
      var shape = layerLayers[Object.keys(layerLayers)[0]];

      return shape;
    };

    self.isVectorLayer = function (layer) {
      // e.g. has geojson but not a marker
      return layer.state().properties &&
          !layer.state().properties.icon;
    };
  };

  return control;
});

